import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { MaintenanceService } from "../services/maintenance.service";
import { AuthService } from "../services/auth.service";

export const maintenanceGuard: CanActivateFn = async (route, state) => {
  const maintenanceService = inject(MaintenanceService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Allow navigation to the maintenance page itself
  if (state.url === "/maintenance") {
    const isMaintenance = await maintenanceService.checkStatus();
    // Staff users should be able to see the club app even in maintenance mode to test it
    if (!isMaintenance || authService.isStaff()) {
      return router.parseUrl("/");
    }
    return true;
  }

  const isMaintenance = await maintenanceService.checkStatus();
  // Staff users should NOT be blocked by maintenance mode
  if (isMaintenance && !authService.isStaff()) {
    return router.parseUrl("/maintenance");
  }

  return true;
};
